import { render } from "./TableLiteTs.vue?vue&type=template&id=15bb1034&scoped=true&ts=true"
import script from "./TableLiteTs.vue?vue&type=script&lang=ts"
export * from "./TableLiteTs.vue?vue&type=script&lang=ts"

import "./TableLiteTs.vue?vue&type=style&index=0&id=15bb1034&scoped=true&lang=css"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bb1034"]])

export default __exports__